(function(){
  function money(p){return '₹'+Math.round(p/100).toLocaleString('en-IN');}
  function refresh(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(e){e.textContent=c.item_count;});
      document.querySelectorAll('[data-gift-meter]').forEach(function(m){
        var max=+m.dataset.max||1, pct=Math.min(100,Math.round(c.total_price*100/max));
        var f=m.querySelector('[data-gift-fill]'); if(f) f.style.width=pct+'%';
        var next=null;
        m.querySelectorAll('[data-gift-pin]').forEach(function(p){
          var amt=+p.dataset.amt;
          if(c.total_price>=amt) p.classList.add('hit'); else { p.classList.remove('hit'); if(!next) next={amt:amt,label:p.dataset.label||''}; }
        });
        var n=m.querySelector('[data-gift-next]');
        if(n) n.textContent = next ? (money(next.amt-c.total_price)+' more — '+next.label+' free') : 'All gifts unlocked 🎁';
      });
    }).catch(function(){});
  }
  document.addEventListener('submit',function(e){
    var f=e.target.closest('form[action*="/cart/add"]'); if(!f) return;
    if(e.submitter && e.submitter.hasAttribute('formaction')) return;
    e.preventDefault();
    fetch('/cart/add.js',{method:'POST',body:new FormData(f)}).then(function(){refresh();
      var b=e.submitter; if(b){var t=b.textContent;b.textContent='Added ✓';setTimeout(function(){b.textContent=t},1600);}
    });
  });
  refresh();
})();

/* evergreen countdown on product deal strip */
(function(){
  function pad(n){return (n<10?'0':'')+n;}
  document.querySelectorAll('[data-deal]').forEach(function(box){
    var hrs=parseFloat(box.getAttribute('data-hours'))||7;
    var key='sm_deal_'+(box.getAttribute('data-key')||'x');
    var end;
    try{ end=parseInt(localStorage.getItem(key),10); }catch(e){}
    if(!end||isNaN(end)||end-Date.now()>hrs*3600000){ end=Date.now()+hrs*3600000; try{localStorage.setItem(key,end);}catch(e){} }
    var h=box.querySelector('[data-dc-h]'),m=box.querySelector('[data-dc-m]'),s=box.querySelector('[data-dc-s]');
    function tick(){
      var d=end-Date.now();
      if(d<=0){ end=Date.now()+hrs*3600000; try{localStorage.setItem(key,end);}catch(e){} d=hrs*3600000; }
      var t=Math.floor(d/1000);
      h.textContent=pad(Math.floor(t/3600)); m.textContent=pad(Math.floor(t%3600/60)); s.textContent=pad(t%60);
    }
    tick(); setInterval(tick,1000);
  });
})();

/* PDP: split the single description accordion into clean per-topic dropdowns */
(function(){
  var rte = document.querySelector('.pdp .acc .rte');
  if(!rte) return;
  var host = rte.closest('details');
  var acc  = rte.closest('.acc');
  if(!host || !acc) return;

  var ICON = {'why it works':'✦','how to use':'①','product details':'☷','ingredients':'❀','key ingredients':'❀'};

  /* pull the trust line out */
  var trust = rte.querySelector('.sm-trust');
  if(trust) trust.parentNode.removeChild(trust);

  /* hook is already shown above the price - drop the duplicate */
  var hook = rte.querySelector('.sm-hook');
  if(hook && document.querySelector('.pdp .hook')) hook.parentNode.removeChild(hook);

  /* group children by h3 */
  var groups = [], cur = null;
  Array.prototype.slice.call(rte.childNodes).forEach(function(n){
    if(n.nodeType===1 && n.tagName==='H3'){
      cur = {title:(n.textContent||'').trim(), nodes:[]};
      groups.push(cur);
    } else {
      if(!cur){ cur = {title:'Overview', nodes:[]}; groups.push(cur); }
      cur.nodes.push(n);
    }
  });
  if(!groups.length) return;

  /* turn the spec table into cards, and lift ingredients into its own group */
  var ingGroup = null;
  groups.forEach(function(g){
    var tbl = g.nodes.filter(function(n){return n.nodeType===1 && n.matches && n.matches('table');})[0];
    if(!tbl) return;
    var grid = document.createElement('div');
    grid.className = 'specs';
    Array.prototype.slice.call(tbl.querySelectorAll('tr')).forEach(function(tr){
      var k = tr.querySelector('th'), v = tr.querySelector('td');
      if(!k || !v) return;
      var key = (k.textContent||'').trim();
      var val = (v.textContent||'').trim();
      if(/ingredient/i.test(key)){
        var wrap = document.createElement('div');
        wrap.className = 'ing';
        val.split(/\s*,\s*/).filter(Boolean).forEach(function(x){
          var s = document.createElement('span'); s.textContent = x; wrap.appendChild(s);
        });
        ingGroup = {title:'Key ingredients', nodes:[wrap]};
        return;
      }
      var cell = document.createElement('div');
      cell.className = 'sp' + (val.length > 34 ? ' wide' : '');
      var b = document.createElement('b'); b.textContent = key;
      var s2 = document.createElement('span'); s2.textContent = val;
      cell.appendChild(b); cell.appendChild(s2);
      grid.appendChild(cell);
    });
    g.nodes = g.nodes.map(function(n){ return n === tbl ? grid : n; });
  });
  if(ingGroup) groups.push(ingGroup);
  groups = groups.filter(function(g){
    var has = g.nodes.some(function(n){
      return (n.nodeType===1) || (n.nodeType===3 && n.textContent.trim().length);
    });
    return has;
  });

  /* build the dropdowns */
  var frag = document.createDocumentFragment();
  groups.forEach(function(g, i){
    var d = document.createElement('details');
    if(i===0) d.setAttribute('open','');
    var s = document.createElement('summary');
    var ic = ICON[g.title.toLowerCase()];
    s.textContent = (ic ? ic + '  ' : '') + g.title;
    var body = document.createElement('div');
    body.className = 'in rte';
    g.nodes.forEach(function(n){ body.appendChild(n); });
    d.appendChild(s); d.appendChild(body);
    frag.appendChild(d);
  });
  acc.insertBefore(frag, host);
  host.parentNode.removeChild(host);

  if(trust){
    var note = document.createElement('div');
    note.className = 'note trust-note';
    note.innerHTML = trust.innerHTML;
    acc.parentNode.insertBefore(note, acc.nextSibling);
  }
})();
